import { LifeCycleTypes, useFormEffects } from '@formily/react';
import React from 'react';
import { pathConcat } from '../utils/rPath';
import { useFieldContext } from '../Other';
export const useErrorCollector = names => {
  const {
    preName
  } = useFieldContext();
  const [errors, setErrors] = React.useState({});
  useFormEffects($ => {
    names.forEach(name => {
      const path = pathConcat(preName, name).toString();
      $(LifeCycleTypes.ON_FIELD_CHANGE, path).subscribe(s => {
        setErrors(err => {
          return { ...err,
            [s.name]: s.errors
          };
        });
      });
    });
  });
  return {
    errors
  };
};
//# sourceMappingURL=es/hooks/useErrorCollector.js.map